import { useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom-v5-compat'
import { FlexBox } from 'shared/components/Base/Base'
import { NAV_LEFT_WRAP } from 'shared/components/Nav/NavLeft'
import { Colors } from 'shared/theme/colors'
import styled from 'styled-components'

import { useAnalyticsEvent } from '../../../hooks/useAnalyticsEvent'
import { useLogRocket } from '../../../hooks/useLogRocket'
import { logoutUser } from '../../../redux/actions/auth/authActions'
import { ReduxDispatch } from '../../../redux/store/models'
import { SIGN_IN_PATH } from '../../../Routes'
import { AvatarMenu, AvatarMenuOptions } from './AvatarMenu'

export function VendorNav() {
  const navigate = useNavigate()
  const dispatch: ReduxDispatch = useDispatch()
  const queryClient = useQueryClient()
  const track = useAnalyticsEvent()

  useLogRocket()

  const handleLogout = () => {
    track('profile_logout_click')

    queryClient.clear()

    dispatch(logoutUser()).then(() => {
      navigate(SIGN_IN_PATH)
    })
  }

  return (
    <FlexBox mt={1}>
      <div id={NAV_LEFT_WRAP} />
      <NavWrap>
        <AvatarMenu handleLogout={handleLogout} options={[AvatarMenuOptions.LOGOUT]} />
      </NavWrap>
    </FlexBox>
  )
}

const NavWrap = styled(FlexBox)`
  width: 100%;
  background-color: ${Colors.bgGray};
  position: relative;
  align-items: center;
  justify-content: flex-end;
`
